<template>
  <v-layout>
    <!-- <v-dialog v-model="showNotification" max-width="1000" persistent>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Notifications</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="showNotification=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-dialog>-->
    <v-flex xs12 v-if="!$auth.loading">
      <v-title v-show="!$auth.isAuthenticated">
        Welcome to Sign On Glass.
      </v-title>
      <v-card>
        <v-card-text>
          <v-flex xs12 v-if="$auth.isAuthenticated">
            <v-layout row v-if="hasDealer" class="px-0">
              <v-flex xs10 md10 lg10>
                <v-title>Sign On Glass - Admin Panel</v-title>
                <!-- <h3 class="pt-5">Hello, {{ $auth.user.nickname }}</h3> -->
              </v-flex>
              <v-spacer></v-spacer>
              <!-- <v-flex xs2 md2 lg2 align-content-end>
                <AppNotifications />
              </v-flex> -->
              <!-- <v-btn
                @click="showNotification=true"
                :color="notificationCount > 0 ? 'red' : 'primary'"
                dark
                v-if="hasDealer"
              >
                Notifications
                <v-icon>notifications</v-icon>
              </v-btn>-->
            </v-layout>
            <v-layout v-else>
              <h2>
                <span class="alert alert-danger">
                  Please wait as we collect your partner details.
                </span>
              </h2>

              <v-progress-circular
                v-if="authorising"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
            <v-flex sm12 md12 lg12>
              <message-alert :component="message"></message-alert>
            </v-flex>
          </v-flex>
          <v-flex sm12>
            <!-- <p>The Vonex Channel Partner Portal</p>
            <hr /> -->
            <v-btn
              name="login"
              color="primary"
              @click="login"
              v-if="!$auth.isAuthenticated"
              data-cy-login
            >
              Login
            </v-btn>
            <!--<a class="btn btn-primary btn-lg" href="/getting-started" target="_blank" role="button">Getting Started</a>-->
            <!-- <hr />
            <order-create
              v-if="
                $auth.isAuthenticated &&
                  hasDealer &&
                  authLevel &&
                  authLevel.toLowerCase() !== 'interested'
              "
            ></order-create> -->
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import AppNotifications from '@/components/app-notifications';
import { httpError } from '@/models/httpError';
import { createNamespacedHelpers, mapActions, mapState } from 'vuex';
const { mapState: mapOrderState, mapGetters: mapOrderGetters } =
  createNamespacedHelpers(`orders`);

import { mapAuthFields } from '../store/modules/orders';

const { mapGetters: mapAuthGetters, mapActions: mapAuthActions } =
  createNamespacedHelpers(`orders/auth`);

const { mapActions: mapNotificationsActions } =
  createNamespacedHelpers(`orders/notifications`);

export default {
  name: 'Home',
  components: {
    AppNotifications,
  },
  data() {
    return {
      showNotification: false,
      notificationCount: 0,
      formIsSaved: false,
      authorising: false,
    };
  },
  methods: {
    ...mapActions('menuPermissions', ['getMenuPermissions']),
    ...mapAuthActions(['setAuth', 'setMessage']),
    ...mapNotificationsActions(['getNewNotificationCount']),
    ...mapActions('orders', ['getDealerFromEmail']),
    login: function () {
      this.$auth.loginWithRedirect();
    },
    hasNewNotifications() {
      let vm = this;
      if (vm.getNewNotificationCount > 0) return 'red';
      else return 'primary';
    },
  },
  computed: {
    ...mapAuthGetters(['auth']),
    ...mapOrderGetters(['hasDealer', 'hasOrder', 'authLevel', 'authGroup']),
    ...mapState('orders/auth', ['message']),
    loading() {
      return this.$auth.loading;
    },
  },
  mounted() {
    let vm = this;
    vm.setMessage(
      new httpError({
        message: '',
        httpStatus: 0,
      })
    );
  },
  watch: {
    loading: async function (newValue, oldValue) {
      let vm = this;
      vm.setMessage(
        new httpError({
          message: '',
          httpStatus: 0,
        })
      );
      if (vm.loading == false && this.$auth.isAuthenticated) {
        vm.setAuth(await this.$auth.getIdTokenClaims());
        vm.authorising = true;
        vm.getDealerFromEmail()
          .then((data) => {
            vm.authorising = false;
            vm.$ga.set('userId', data.ubDealerID);
            if (data.authLevel.toLowerCase() == 'interested') {
              vm.$router.push('/dealer-register');
            } else {
            }

            vm.getMenuPermissions();

            return Promise.resolve();
          })
          .catch(function (data) {
            vm.authorising = false;
            vm.setMessage(
              new httpError({
                message: 'unable to login' + data,
                httpStatus: 500,
              })
            );
            vm.$router.push('/');
          });
      }
    },
  },
};
</script>
<style scoped>
.btn-primary {
  background: #468f65;
  border: 1px solid #468f65;
}

.card {
  text-decoration: none;
  color: #000;
}
</style>
